import { tm } from '../../../tm'
import type { Project } from '@captaincause/types'

interface ProjectNameProps {
  project: Project
  className?: string
}

export function ProjectName({ project, className = '' }: ProjectNameProps) {
  return (
    <div
      className={tm(
        'p-6 pt-0 text-2xl font-semibold leading-8 -tracking-[0.72px] text-white',
        className,
      )}
      style={{
        boxShadow: '0px 0px 20px 20px #00000069',
        background: '#00000069',
      }}
    >
      {project.name}
    </div>
  )
}
